export default {
  width: '100%',
  height: '100%',
};


/** WEBPACK FOOTER **
 ** ./src/VO2/libs/core/youtube-player/default-configs.js
 **/